import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { LeagueData } from "src/mockup/LoginData";

export const getUserLeagues = async (leagueInfo, accessAuthToken, pocToken, signal?: AbortSignal): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/fantasy_leagues/get_user_leagues`;

    // console.log("POC TOKEN GET TEAMS DATA", pocToken);
    // console.log("LEAGUE INFOOOO", leagueInfo);

    const data: LeagueData = {
      integration_name: leagueInfo.integration_name,
      user_id: leagueInfo.user_id ? leagueInfo.user_id : "",
      user_email: leagueInfo.user_id ? leagueInfo.user_id : "",
      sport: "NFL",
      season: "",
      leagueToken: leagueInfo.token ? leagueInfo.token : "",
      // year: "2025",
      pocToken: pocToken,
    };

    // console.log("get_user_leagues data", data);
    // console.log("accessAuthToken before fetch on getUserLeagues", accessAuthToken);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(data),
      signal: signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Request failed. Please try again");
    }

    const responseData = await response.json();
    // console.log("RESPONSE DATA DE GET TEAMS DATA", responseData);

    return responseData;
  } catch (error) {
    console.error("Something went wrong when getting teams data", error);
    showErrorToast("Something went wrong when getting teams data");
    throw error;
  }
};
